module.exports = __webpack_public_path__ + "static/media/digital-tachograph.bef3092c.svg";